import React from "react";
import { Link } from "react-router-dom";
import { Box, Dialog, Typography, Grid, TextField, Button } from "@mui/material";
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ImageIcon from '@mui/icons-material/Image';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import './uploadMediaPopup.scss';
import CloseIcon from '@mui/icons-material/Close';
import { VideoFile } from "@mui/icons-material";
import { Image } from "@mui/icons-material";
import { AudioFile } from "@mui/icons-material";
import { Fullscreen } from "@mui/icons-material";
import { Camera } from "@mui/icons-material";
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';

import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GetProjectUUID } from '../../assets/script/commonFunction';
import { getProjectJSON, SERVER_STATUS } from '../../axios/ApiProvider';
import { getMaxZIndex, changeZeroSecond } from '../../component/video-edit/commonFunction';
import { changedJSON_Store, thumbNails_Store, uploadingFiles_Store, ProjectJSON_Store } from '../../store/actions/projectdata';
import { getNewVideoInformation, getImageInformation, getThumbnails, getDuration, getVideoAssetFps, getNewAudioInformation, getVideoLoadedData } from '../../component/video-edit/webGL/commonFunc';
import { dataLoaded_Store, VideoElements_Store, imageElements_Store, audioElements_Store } from '../../store/actions/webgldata';
import { CaptureDialog_Store } from "../../store/actions/editAction"
import { webGlSizeOptions } from '../../component/video-edit/videoEdit.config';
import PricingModal from "../Pricing/pricingModal"; ;

let tempVideoEls = null;
let tempProjectJSON = null;
let tempLoadingData = null;

let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }

export const UploadMediaPopup = ({ popUp, setPopUp, from }) => {
  const dispatch = useDispatch();
  const projectUUID = GetProjectUUID();
  const loginState = useSelector((store) => store.maindata.loginState);
  const thumbNails = useSelector(store => store.projectdata.thumbNails);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const sequenceNumber = useSelector(store => store.projectdata.sequenceNumber);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const uploadingFiles = useSelector((store) => store.projectdata.uploadingFiles);
  const Time_Count = useSelector((store) => store.videodata.Time_Count);
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const [titleText, setTitleText] = useState("");
  const [selectableCategs, setSelectableCategs] = useState(["video", "image"]);
  const [dismissable, setDismissable] = useState(true)

  useEffect(() => {setTitleText(languageStrs.welcomNewProject)}, [])
  useEffect(() => { tempVideoEls = { ...videoElements } }, [videoElements]);
  useEffect(() => { tempProjectJSON = { ...ProjectJSON } }, [ProjectJSON]);
  useEffect(() => { tempLoadingData = { ...uploadingFiles } }, [uploadingFiles]);

  const [userData, setUserData] = useState({})

  useEffect(() => {
    if (from === "feature-add-image-to-video") {
      setTitleText("Add Image to Video")
    }
    if (from === "feature-add-music-to-video") {
      setTitleText("Add Music to Video")
    }
    if (from === "feature-add-text-to-video") {
      setTitleText("Add Text to Video")
    }
    if (from === "feature-filter-to-video") {
      setTitleText("Filter Video")
    }
    if (from === "feature-add-transitions-to-video") {
      setTitleText("Add Transitions to Video")
    }
    if (from === "feature-add-subtitle-to-video") {
      setTitleText(languageStrs.add_subtitle_video)
    }
    if (from === "feature-auto-subtitles") {
      setTitleText(languageStrs.auto_subtitles)
    }
    if (from === "feature-transcribe-video") {
      setTitleText(languageStrs.transcripbe_video)
    }
    if (from === "feature-translate-video") {
      setTitleText(languageStrs.translate_video)
    }
    if (from === "feature-crop-video") {
      setTitleText(languageStrs.crop_video)
    }
    if (from === "feature-cut-video") {
      setTitleText(languageStrs.cut_video)
    }
    if (from === "feature-joinmerge-video") {
      setTitleText(languageStrs.joinmarge_video)
    }
    if (from === "feature-loop-video") {
      setTitleText(languageStrs.loop_video)
    }
    if (from === "feature-resize-video") {
      setTitleText(languageStrs.resize_video)
    }
    if (from === "feature-rotate-video") {
      setTitleText(languageStrs.rotate_video)
    }
    if (from === "feature-compress-video") {
      setTitleText(languageStrs.compress_video)
      setDismissable(false)
      setSelectableCategs(["video"])
    }
    if (from === "feature-convert-video") {
      setTitleText(languageStrs.convert_video)
      setDismissable(false)
      setSelectableCategs(["video"])
    }
    
  }, [from])

  const [userPlan, setUserPlan] = useState(0);
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)
    setUserData(tempData)
    setUserPlan(tempData.subscription)
  }, [loginState])
  const [showPricingPageModal, setShowPricingPageModal] = useState(false)
  const handleClosePricingModal = () => {
    setShowPricingPageModal(false)
  }

  const chooseVideoFunc = async (e) => {
    if (!e || !e.target || !e.target.files[0]) {
      window.toastr.warning('file select error')
      return
    }
    const newUUID = uuidv4();
    let videofile = e.target.files[0];
    const videoLength = Object.keys(tempVideoEls).length;

    let video_type = videofile.type;
    let allow_type = ['video/mp4', 'video/webm', 'video/quicktime'];
    let accep_type = allow_type.find((type) => type === video_type);

    if (!accep_type) {
      window.toastr.error("Can't load this video file")
      return
    }

    let duration = await getDuration(videofile)
    if (duration === Infinity) {
      window.toastr.info('video type error, cant get duration', 'can`t load this video')
      return
    }

    let fps = await getVideoAssetFps(videofile)
    console.log(fps);
    // if (fps === 0) {
    //   window.toastr.info('video type error, cant get fps', 'can`t load this video')
    //   return
    // }

    console.log("VideooFile Size : " + videofile.size + " duration : " + duration + " user plan " + userPlan)
    let msg = "";
    if (loginState) {
      if (userPlan == 0) {
        if (videofile.size > 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 1 Gbyte, please ugprade your subscription to upload larger files';
        }
        if (duration > 10 * 60) {
          msg = 'You cannot upload files longer than 10 minutes, please upgrade your subscription to upload longer videos';
        }
      } else if ((userPlan == 1) || (userPlan == 4)) {
        if (videofile.size > 10 * 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 10 Gbyte, please ugprade your subscription to upload larger files';
        }
        if (duration > 25 * 60){
          msg = 'You cannot upload files longer than 25 minutes, please upgrade your subscription to upload longer videos';
        }
      }
      else if ((userPlan == 2) || (userPlan == 3) || (userPlan == 5) || (userPlan == 6))  {
        if (videofile.size > 50 * 1024 * 1024 * 1024) {
          msg = 'You cannot upload files larger than 50 Gbyte, contact info@kedy.ai';
        }
        if( duration > 720 * 60){
          msg = 'In order to upload files longer than 2 hours, contact info@kedy.ai';
        }
      }
      let storage_flag = userData?.storage_usage_state
      if (!storage_flag) {
        msg = 'You have run out of Cloud Storage Space with your current plan, please upgrade your subscription for more cloud space.';
      }
    } else {
      if (videofile.size > 250 * 1024 * 1024) {
        msg = 'You cannot upload files larger than 250 Mbytes, please signup and ugprade your subscription to upload larger files';
      }
      if (duration > 5 * 60) {
        msg = 'You cannot upload files longer than 5 minutes, please signup and upgrade your subscription to upload longer videos';
      }
    }
    if (msg !== "") {
      window.toastr.info(msg)
      setShowPricingPageModal(true);
      setPopUp(false)
      return
    }

    setPopUp(false)

    let newProjectJSON = { ...ProjectJSON }
    if (Object.keys(videoElements).length === 0) {
      const objURL = URL.createObjectURL(videofile);
      getVideoLoadedData(objURL, uuidv4(), { segment_start: 10 }, newUUID, (res, videoPlayer) => {
        const videoPlayerW = videoPlayer.videoWidth;
        const videoPlayerH = videoPlayer.videoHeight;
        if (videoPlayerH / videoPlayerW > 1) {
          newProjectJSON.width = webGlSizeOptions[0].wSize.width;
          newProjectJSON.height = webGlSizeOptions[0].wSize.height;
          dispatch(ProjectJSON_Store(newProjectJSON));
        }
      })
    }

    let fileData = { pc: 0, type: 'video', name: videofile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));

    let tempThumbNails = [];
    let _thumbNails = await getThumbnails(videofile, 1);

    _thumbNails.forEach((thumbNail) => {
      let tempData = {
        uuid: uuidv4(),
        content_type: 'blob',
        timestamp: thumbNail.time,
        signed_url: URL.createObjectURL(thumbNail.file)
      }

      tempThumbNails.push(tempData);
    });

    let maxZIndex = getMaxZIndex(ProjectJSON);
    let props = [newProjectJSON, videofile, '', duration, fps, newUUID, projectUUID, videoLength, maxZIndex]
    getNewVideoInformation(...props,
      async (videoPlayer, videoInfo) => {
        dispatch(thumbNails_Store({ ...thumbNails, [newUUID]: tempThumbNails }));
        let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
        let startTime = Time_Count.getTime()

        videoInfo = {
          ...videoInfo,
          timeline_start: startTime,
          timeline_end: videoInfo.duration + startTime
        }

        changedJSON.flag = true
        changedJSON.videos = { [newUUID]: videoInfo }

        const titleHasDefaultPrefix = typeof ProjectJSON?.title === 'string' && ProjectJSON.title.startsWith('Project - ');
        if ((Number(sequenceNumber?.c) === 0 || Object.keys(ProjectJSON?.videos || {}).length === 0) && titleHasDefaultPrefix) {
          changedJSON.title = videofile.name.replace(/\.[^/.]+$/, "");
        }
        dispatch(VideoElements_Store({ ...tempVideoEls, [newUUID]: videoPlayer }));
        dispatch(changedJSON_Store(changedJSON));
        changeZeroSecond(videoInfo, dispatch)
      },
      (tempAssets) => {
        let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
        changedData = { ...changedData, asset: { ...tempAssets } };
        dispatch(changedJSON_Store(changedData));
      },
      async (newAssets, assetUUID) => {
        let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
        if (!tempProjectJSON.videos[newUUID]) return;
        changedData.videos[newUUID] = tempProjectJSON.videos[newUUID];
        // changedData.videos[newUUID].asset_uuid = assetUUID;

        const JSONdata = await getProjectJSON(projectUUID);
        const projectData = JSONdata?.data[projectUUID];

        if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost')
          changedData = { ...changedData, asset: { ...newAssets } };
        else changedData = { ...changedData, asset: projectData.asset };

        // let fileItem = { ...tempLoadingData[newUUID], state: true };
        // dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
        dispatch(changedJSON_Store(changedData));
      },
      () => { dispatch(dataLoaded_Store(true)); },
      (e) => {
        let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
        let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
        dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
        if (Number(pc) === 100) {
          setTimeout(() => {
            let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc), state: true };
            dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
          }, 1000)
        }
      })


  }

  const chooseAudioFunc = async ({ target }) => {
    if (!target || !target.files[0]) {
      window.toastr.warning('file select error')
      return
    }

    const newUUID = uuidv4();
    let audiofile = target.files[0];

    let audio_type = audiofile.type;
    let allow_type = ['audio/mp3', 'audio/mpeg', 'audio/wav'];
    let accep_type = allow_type.find((type) => type === audio_type);

    if (!accep_type) {
      window.toastr.error("Can't load this video file")
      return
    }

    let duration = await getDuration(audiofile)
    if (duration === Infinity) {
      window.toastr.info('audio type error', 'can`t load this audio')
      return
    }

    if (!loginState) {
      if (audiofile.size > 250 * 1024 * 1024 || duration > 5 * 60) {
        let title = 'Please sign in or sign up to upload audios'
        let content = 'larger than 250 Mbytes or longer than 5 minutes'
        window.toastr.info(title, content)
        return
      }
    } else {
      let flag = userData?.storage_usage_state
      if (!flag) {
        window.toastr.error('You have run out of Cloud Storage Space with your current plan, you need to upgrade your account to upload files to a project')
        return
      }
    }
    setPopUp(false)

    let fileData = { pc: 0, type: 'audio', name: audiofile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));

    getNewAudioInformation(ProjectJSON, audiofile, duration, newUUID, projectUUID, (audioPlayer, audioInfo) => {
      let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      let startTime = Time_Count.getTime()

      const audioKeys = Object.keys(ProjectJSON.audios);
      audioKeys.map(aItemKey => {
        if(startTime < ProjectJSON.audios[aItemKey].timeline_end){
          startTime = ProjectJSON.audios[aItemKey].timeline_end;
        }
      })

      audioInfo.timeline_start = startTime
      audioInfo.timeline_end = audioInfo.duration + startTime
      changedJSON.audios = { [newUUID]: audioInfo }
      dispatch(audioElements_Store({ ...tempVideoEls, [newUUID]: audioPlayer }));
      dispatch(changedJSON_Store(changedJSON));
    }, async (newAssets, assetUUID) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      if (!tempProjectJSON.audios[newUUID]) return;
      changedData.audios[newUUID] = tempProjectJSON.audios[newUUID];

      const JSONdata = await getProjectJSON(projectUUID);
      const projectData = JSONdata?.data[projectUUID];

      if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost') {
        changedData = { ...changedData, asset: { ...newAssets } };
      } else changedData = { ...changedData, asset: projectData.asset };

      let fileItem = { ...tempLoadingData[newUUID], state: true };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      dispatch(changedJSON_Store(changedData));
    }, () => { dispatch(dataLoaded_Store(true)) }, (e) => {
      let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
      let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
    })


  }

  const chooseImageFunc = async (e) => {
    if (!e || !e.target || !e.target.files[0]) window.toastr.warning('file select error');
    if (!e || !e.target || !e.target.files[0]) return;

    if (loginState) {
      let flag = userData?.storage_usage_state
      if (!flag) {
        window.toastr.error('You have run out of Cloud Storage Space with your current plan, you need to upgrade your account to upload files to a project')
        return
      }
    }

    setPopUp(false)

    const newUUID = uuidv4();
    let imgFile = e.target.files[0];
    const newImgUrl = URL.createObjectURL(imgFile);
    const originalFileName = imgFile.name;
    const mimeType = imgFile.type;

    let fileData = { pc: 0, type: 'image', name: imgFile.name, state: false }
    dispatch(uploadingFiles_Store({ ...uploadingFiles, [newUUID]: fileData }));
    dispatch(dataLoaded_Store(false));


    let maxZIndex = getMaxZIndex(ProjectJSON);
    let props = [ProjectJSON, originalFileName, mimeType, newImgUrl, newUUID, projectUUID, 'image', maxZIndex]
    await getImageInformation(...props, async (img, imageInfo) => {
      let imgThumbNail = [{ uuid: uuidv4(), content_type: 'blob', signed_url: newImgUrl }];
      dispatch(thumbNails_Store({ ...thumbNails, [imageInfo.asset_uuid]: imgThumbNail }));

      let changedJSON = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      changedJSON.images = { [newUUID]: imageInfo }
      dispatch(imageElements_Store({ ...imageElements, [newUUID]: img }));
      dispatch(changedJSON_Store(changedJSON));
    }, async (newAssets, assetUUID) => {
      let changedData = { videos: {}, audios: {}, images: {}, asset: {}, text: {} }
      if (!tempProjectJSON.images[newUUID]) return;
      changedData.images[newUUID] = tempProjectJSON.images[newUUID]

      const JSONdata = await getProjectJSON(projectUUID);
      const projectData = JSONdata?.data[projectUUID];

      if (JSONdata.state !== 'success' || SERVER_STATUS === 'localhost')
        changedData = { ...changedData, asset: { ...newAssets } };
      else changedData = { ...changedData, asset: projectData.asset };

      let fileItem = { ...tempLoadingData[newUUID], state: true };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
      dispatch(changedJSON_Store(changedData));
    }, () => { dispatch(dataLoaded_Store(true)); }, (e) => {
      let pc = parseFloat(e.loaded / e.total * 100).toFixed(2);
      let fileItem = { ...tempLoadingData[newUUID], pc: Number(pc) };
      dispatch(uploadingFiles_Store({ ...tempLoadingData, [newUUID]: fileItem }))
    });


  }

  const handleOpenWebcamCapture = () => {
    setPopUp(false);
    dispatch(CaptureDialog_Store({
      webcam: true
    }))
  }

  const handleOpenWSCapture = () => {
    setPopUp(false);
    dispatch(CaptureDialog_Store({
      webcamScreen: true
    }))
  }

  const handleOpenScreenCapture = () => {
    setPopUp(false);
    dispatch(CaptureDialog_Store({
      screen: true
    }))
  }
  return (
    <>
    <Dialog open={popUp}
      className='upload-media-popup-wrapper'
      onClose={() => { if (dismissable) { setPopUp(false) } }}
    >
      <Box className="um-popup-contain">
        {dismissable && (
          <Box className="popup-close-btn" onClick={() => { setPopUp(false); }}>
            <CloseIcon />
          </Box>
        )}

        <Typography sx={{typography: {xl: 'h1', md: 'h2', xs: 'h4'}}} textAlign="center" gutterBottom>
          {titleText}
        </Typography>

        <Typography sx={{typography: {xl: 'h4', md: 'h5', xs: 'h6'}}} textAlign="center" gutterBottom>
          Please add media to proceed
        </Typography>

          <Grid
            container
            gap={2}
            sx={{
              flexWrap: { xs: 'wrap', md: 'nowrap' },
              width: { xs: '100%', sm: '48%', md: '100%' },
              display: { xs: 'flex', sm: 'inline-flex', md: 'flex' },
              paddingRight: { xs: '0', sm: 1, md: '0' }
            }}
          >
            <Grid item xs={12} md={4}>
              <label htmlFor="video_input" style={{ width: "100%" }}>
                <Button
                  variant="contained"
                  fullWidth
                  component="span"
                  sx={{ cursor: 'pointer', flexDirection: 'column-reverse', alignItems: 'center' ,textAlign: 'center', padding: '4px 0'}}
                >
                  Upload <br /> Video
                  <VideoFile sx={{fontSize: '48px !important'}} />
                </Button>
              </label>
              <input
                type="file"
                accept=".mp4, .m4v, .webm, .mov"
                onChange={chooseVideoFunc}
                disabled={!selectableCategs.includes("video")}
                id="video_input"
                style={{ display: "none" }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <label htmlFor="image_input" style={{ width: "100%" }}>
                <Button
                  variant="contained"
                  fullWidth
                  component="span"
                  sx={{ cursor: 'pointer', flexDirection: 'column-reverse', textAlign: 'center', padding: '4px 0'}}
                >
                  Upload <br /> Image
                  <Image sx={{fontSize: '48px !important'}} />
                </Button>
              </label>
              <input
                type="file"
                accept=".jpg, .jpeg, .png, .svg, .gif"
                onChange={chooseImageFunc}
                disabled={!selectableCategs.includes("image")}
                id="image_input"
                style={{ display: "none" }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <label htmlFor="audio_input" style={{ width: "100%" }}>
                <Button
                  variant="contained"
                  fullWidth
                  component="span"
                  sx={{ cursor: 'pointer', flexDirection: 'column-reverse', textAlign: 'center', padding: '4px 0' }}
                >
                  Upload <br /> Audio
                  <AudioFile sx={{fontSize: '48px !important'}} />
                </Button>
              </label>
              <input
                type="file"
                accept=".mp3, .mpeg, .wav"
                onChange={chooseAudioFunc}
                id="audio_input"
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            gap={2}
            sx={{
              flexWrap: { xs: 'wrap', md: 'nowrap' },
              width: { xs: '100%', sm: '48%', md: '100%' },
              display: { xs: 'flex', sm: 'inline-flex', md: 'flex' },
              paddingLeft: { xs: '0', sm: 1, md: '0' }
            }}
            mt={3}
          >
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleOpenWSCapture}
                sx={{flexDirection: 'column-reverse', height: '100%', textAlign: 'center', padding: '4px 0'}}                
              >
                Record<br />Screen & Webcam
                <VideoCameraBackIcon sx={{fontSize: '48px !important'}} />
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleOpenWebcamCapture}
                sx={{flexDirection: 'column-reverse', height: '100%', textAlign: 'center', padding: '4px 0'}}
              >
                Record <br /> Webcam
                <Camera sx={{fontSize: '48px !important'}} />
              </Button>
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                variant="contained"
                fullWidth
                onClick={handleOpenScreenCapture}
                sx={{flexDirection: 'column-reverse', height: '100%', textAlign: 'center', padding: '4px 0'}}
              >
                Record <br /> Screen
                <Fullscreen sx={{fontSize: '48px !important'}} />
              </Button>
            </Grid>
          </Grid>
        {/* <Grid container spacing={4} margin={'auto'}>
          <div className={mobileScreenDetect? 'w-full':"welcom-container"}>
            <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3" : "media-center-btn"} onClick={handleOpenWSCapture}>
              <Box className='choose-btn-text' textAlign="center">
                {languageStrs.add_webcam_screen}
              </Box>
            </Box>
            <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3" : "media-fst-btn"} onClick={handleOpenWebcamCapture}>
              <Box className='choose-btn-text' textAlign="center">
                {languageStrs.add_webcam}
              </Box>
            </Box>
            <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3" : "media-fiveth-btn"} onClick={handleOpenScreenCapture}>
              <Box className='choose-btn-text' textAlign="center">
                {languageStrs.add_screen}
              </Box>
            </Box>
             <label htmlFor="video_input" style={{width:  mobileScreenDetect? '100%' : 'auto'}}>
              <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3":"media-snd-btn"} >
                <Box className='choose-btn-text' textAlign="center">
                  {languageStrs.add_video}
                </Box>
                <input type="file"
                  accept=".mp4, .m4v, .webm, .mov"
                  onChange={chooseVideoFunc}
                  disabled={!selectableCategs.includes("video")}
                  style={{ display: "none" }} id="video_input"
                />
              </Box>
            </label>
            <label className={`${!selectableCategs.includes("image") ? "media-btn-disable" : ""} `} htmlFor="image_input" style={{width:  mobileScreenDetect? '100%' : 'auto'}}>
              <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3" : "media-third-btn"}>
                <Box className='choose-btn-text' textAlign="center">
                  {languageStrs.add_image}
                  <input type="file"
                    id="image_input"
                    onChange={chooseImageFunc}
                    style={{ display: "none" }}
                    accept=".jpg, .jpeg, .png, .svg, .gif"
                    disabled={!selectableCategs.includes("image")}
                  />
                </Box>
              </Box>
            </label>
            <label className={`${!selectableCategs.includes("image") ? "media-btn-disable" : ""} `} htmlFor="audio_input" style={{width:  mobileScreenDetect? '100%' : 'auto'}}>
              <Box className={mobileScreenDetect? "col-md-6 media-btn mb-3" : "media-forth-btn"} >
                  <Box className='choose-btn-text'>
                    {languageStrs.add_audio}
                  </Box>
                  <input type={`file`} style={{ display: "none" }}
                    id="audio_input"
                    accept=".mp3, .mpeg, .wav" onChange={chooseAudioFunc}
                  />
              </Box>
            </label>
          </div>
        </Grid> */}
      </Box>
    </Dialog>
    <PricingModal open={showPricingPageModal} onCloseModal={handleClosePricingModal} />
    </>
    
  )
}